/* Southern Atelier – cart helpers. Uses Horizon's cart drawer + Shopify standard cart events. */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const root = () => window.Shopify?.routes?.root || '/';

function drawerSectionIds() {
  return [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

/* Adds one variant ({ id, quantity, properties }) or several at once ({ items: [{ id, quantity, properties }] }) */
export async function saAddToCart({ id, quantity = 1, source = document, properties, items } = {}) {
  const lines = items || [{ id, quantity, properties }];
  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity || 1 })),
      promise: deferred.promise,
    })
  );
  const body = {
    items: lines.map((l) => ({ id: Number(l.id), quantity: l.quantity || 1, properties: l.properties })),
    sections: drawerSectionIds().join(','),
  };
  try {
    const res = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (data.status) {
      deferred.resolve({ detail: { didError: true } });
      throw new Error(data.description || data.message || 'Add to cart failed');
    }
    const cart = await fetch(root() + 'cart.js').then((r) => r.json());
    const itemCount = lines.reduce((n, l) => n + (l.quantity || 1), 0);
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'sa', itemCount, sections: data.sections, didError: false },
    });
    updateCounts(cart.item_count);
    openCartDrawer();
    return cart;
  } catch (err) {
    deferred.resolve({ detail: { didError: true } });
    throw err;
  }
}

export function openCartDrawer() {
  const d = document.getElementById('cart-drawer');
  if (d && typeof d.open === 'function' && !d.isOpen) d.open();
  else if (!d) window.location.href = root() + 'cart';
}

function updateCounts(n) {
  document.querySelectorAll('[data-sa-cart-count]').forEach((el) => {
    el.textContent = n;
    el.hidden = !n;
  });
}

document.addEventListener(StandardEvents.cartLinesUpdate, (e) => {
  e.promise?.then(({ cart, detail }) => {
    if (detail?.didError) return;
    fetch(root() + 'cart.js').then((r) => r.json()).then((c) => updateCounts(c.item_count)).catch(() => {});
  });
});

window.saCart = { add: saAddToCart, open: openCartDrawer };
